var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Tabs',{attrs:{"value":_vm.$route.name},on:{"on-click":_vm.goToTab}},_vm._l((_vm.tabs),function(ref){
var name = ref.name;
var labelKey = ref.meta.labelKey;
return _c('TabPane',{key:name,attrs:{"label":_vm.$t(labelKey),"name":name}})}),1),_c('router-view'),_c('DeleteUserModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }